import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../utils/navigationRoutes";

export const useBackNavigation = () => {
  const navigate = useNavigate();

  const goBack = (fallbackRoute?: string) => {
    // React Router stores in-app stack index in history.state.idx
    const canGoBackInApp = (window.history.state?.idx ?? 0) > 0;

    if (canGoBackInApp) {
      navigate(-1);
    } else if (fallbackRoute) {
      // Fallback to specific route
      navigate(fallbackRoute, { replace: true });
    } else {
      // Default fallback to home page
      navigate("/glucera" + GluceraNavigationRoutes.HOME, { replace: true });
    }
  };

  return { goBack };
};
